import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
let TaskRequisitionModule = class TaskRequisitionModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.listOutstanding = {};
        this.isOutstandingJci = false;
        this.isOutstandingFpk = false;
        this.isOutstandingCrf = false;
    }
    get getListOutstanding() {
        return this.listOutstanding;
    }
    get getIsOutstandingJci() {
        return this.isOutstandingJci;
    }
    get getIsOutstandingFpk() {
        return this.isOutstandingFpk;
    }
    get getIsOutstandingCrf() {
        return this.isOutstandingCrf;
    }
    ['setListOutstanding'](data) {
        this.listOutstanding = data;
    }
    ['setIsOutstandingJci'](data) {
        this.isOutstandingJci = data;
    }
    ['setIsOutstandingFpk'](data) {
        this.isOutstandingFpk = data;
    }
    ['setIsOutstandingCrf'](data) {
        this.isOutstandingCrf = data;
    }
    ['callListOutstanding']() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/history/outstandingsummary?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const data = response.data.result.content;
                    this.context.commit('setListOutstanding', data);
                    this.context.commit('setIsLoading', false);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TaskRequisitionModule.prototype, 'setListOutstanding', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TaskRequisitionModule.prototype, 'setIsOutstandingJci', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TaskRequisitionModule.prototype, 'setIsOutstandingFpk', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TaskRequisitionModule.prototype, 'setIsOutstandingCrf', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], TaskRequisitionModule.prototype, 'callListOutstanding', null);
TaskRequisitionModule = __decorate([
    Module
], TaskRequisitionModule);
export default TaskRequisitionModule;
